import { render, staticRenderFns } from "./CommunityTile.vue?vue&type=template&id=58f1f985&scoped=true"
import script from "./CommunityTile.vue?vue&type=script&lang=js"
export * from "./CommunityTile.vue?vue&type=script&lang=js"
import style0 from "./CommunityTile.vue?vue&type=style&index=0&id=58f1f985&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f1f985",
  null
  
)

export default component.exports